import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { aboutContent } from '../data/mock';

const About = () => {
  return (
    <main className="pt-20 bg-white">
      {/* Hero - Imagem de Manaus/Amazonas */}
      <section className="relative py-24 lg:py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1520464399004-1f1e8e938bb3?w=1920&q=80" 
            alt="Vista aérea de Manaus - Amazonas"
            className="w-full h-full object-cover"
          />
          {/* Overlay leve e claro */}
          <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/70 to-white/40" />
        </div>
        <div className="container-main relative z-10">
          <div className="max-w-3xl">
            <span className="caption text-[#3E6B2A] mb-4 block">Quem somos</span>
            <h1 className="heading-display text-[#0F172A] mb-6">
              {aboutContent.title}
            </h1>
            <p className="body-large text-[#475569]">
              {aboutContent.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Story - Nossa História */}
      <section className="section-spacing bg-[#F7FAFC]">
        <div className="container-main">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="aspect-[4/3] rounded-lg overflow-hidden border border-[#E2E8F0] shadow-sm">
                <img 
                  src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80" 
                  alt="Profissional analisando documentos"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-[#3E6B2A] text-white p-6 rounded-lg shadow-lg">
                <span className="text-5xl font-bold">1990</span>
                <p className="text-sm text-white/90 mt-1">Ano de fundação</p>
              </div>
            </div>
            <div>
              <span className="caption mb-4 block">Nossa História</span>
              <h2 className="heading-1 mb-6">Mais de três décadas de excelência</h2>
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="body-medium mb-6 last:mb-0">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-spacing bg-white">
        <div className="container-main">
          <div className="text-center mb-16">
            <span className="caption mb-4 block">Nossos valores</span>
            <h2 className="heading-1">O que nos move</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {aboutContent.values.map((value, index) => (
              <div 
                key={index} 
                className="bg-[#F7FAFC] p-8 rounded-lg border border-[#E2E8F0] hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 bg-[#E7F2E3] rounded-lg flex items-center justify-center mb-5">
                  <Check size={20} className="text-[#3E6B2A]" />
                </div>
                <h3 className="heading-4 mb-3">{value.title}</h3>
                <p className="body-small">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Methodology */}
      <section className="section-spacing bg-[#F7FAFC]">
        <div className="container-main">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <span className="caption mb-4 block">Metodologia</span>
              <h2 className="heading-2 mb-6">Compliance alinhado às normas nacionais e internacionais</h2>
              <p className="body-medium mb-8">
                Nossa metodologia de trabalho segue rigorosamente as normas brasileiras de auditoria 
                e contabilidade, bem como os padrões internacionais quando aplicáveis.
              </p>
              <ul className="space-y-4">
                {[
                  'Normas Brasileiras de Contabilidade (NBC)',
                  'Padrões Internacionais (IFRS)',
                  'Revisão de qualidade em todos os trabalhos',
                  'Equipe em constante atualização técnica'
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#3E6B2A] rounded-full" />
                    <span className="text-[#475569]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-white border border-[#E2E8F0] rounded-lg p-10">
              <blockquote className="text-[#0F172A] text-xl font-medium leading-relaxed mb-6">
                "Confiança se constrói com trabalho sério, resultados consistentes e relacionamentos de longo prazo."
              </blockquote>
              <p className="text-[#64748B] text-sm">Filosofia eLauria</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA - Card claro em vez de faixa verde */}
      <section className="section-spacing bg-white">
        <div className="container-main">
          <div className="bg-[#F7FAFC] border border-[#E2E8F0] rounded-lg p-12 text-center">
            <h2 className="heading-2 text-[#0F172A] mb-4">Faça parte da nossa história</h2>
            <p className="body-medium mb-8 max-w-2xl mx-auto">
              Seja como cliente ou colaborador, venha construir o futuro com a gente.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contato" className="btn-primary">
                Solicitar Proposta
                <ArrowRight size={18} />
              </Link>
              <Link to="/trabalhe-conosco" className="btn-secondary">
                Trabalhe Conosco
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
